/** Amount with the currency of the statement, in the UI language. An unknown code falls back to "12.50 XXX". */
export const formatMoney = (amount: number, currency: string, language: string): string => {
    try {
        return new Intl.NumberFormat(language, { style: 'currency', currency }).format(amount);
    } catch {
        return `${new Intl.NumberFormat(language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)}\u00a0${currency}`;
    }
};

/** Rate in percent (1.5 = 1.5%). */
export const formatRate = (rate: number, language: string): string =>
    new Intl.NumberFormat(language, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(rate / 100);

/** 'YYYY-MM' as "October 2026" (or "Oct 2026"). Months are plain calendar months, so UTC avoids a shift by the browser zone. */
export const formatMonth = (month: string, language: string, style: 'long' | 'short' = 'long'): string => {
    const [y, m] = month.split('-').map(Number);
    return new Date(Date.UTC(y ?? 1970, (m ?? 1) - 1, 1)).toLocaleDateString(language, { month: style, year: 'numeric', timeZone: 'UTC' });
};
